const QUEUE_VERSION = 'v1';

const getScope = () => {
  const rawUser = localStorage.getItem('user');
  const activeStoreId = String(localStorage.getItem('active_store_id') || '').trim();

  let userId = '';
  try {
    const user = rawUser ? JSON.parse(rawUser) : null;
    userId = String(user?._id || '').trim();
  } catch {
    userId = '';
  }

  return {
    userId: userId || 'anon',
    storeId: activeStoreId || 'no-store',
  };
};

const queueKey = () => {
  const { userId, storeId } = getScope();
  return `retail_pos_offline_queue_${QUEUE_VERSION}_${userId}_${storeId}`;
};

const readQueue = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(queueKey()) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
};

const writeQueue = (queue) => {
  localStorage.setItem(queueKey(), JSON.stringify(queue));
};

export const retailPosOfflineQueue = {
  list: () => readQueue(),

  enqueue: (entry) => {
    const txId = String(entry?.transactionId || '').trim();
    if (!txId) return false;

    const queue = readQueue();
    if (queue.some((q) => q.transactionId === txId)) return false;

    queue.push({
      ...entry,
      queuedAt: new Date().toISOString(),
    });
    writeQueue(queue);
    return true;
  },

  // Processes entries in strict FIFO order — the exact order they were enqueued.
  // If an entry fails (for any reason), stops immediately and keeps that entry
  // plus all following ones in the queue for the next flush attempt.
  async flush(processEntry, isOfflineErrorFn) {
    const queue = readQueue();
    if (queue.length === 0) return { ok: true, pending: 0 };

    const remaining = [];
    let lastError = null;
    let failedTransactionId = null;

    for (let i = 0; i < queue.length; i += 1) {
      const entry = queue[i];
      try {
        await processEntry(entry);
      } catch (error) {
        lastError = error;
        failedTransactionId = entry.transactionId;
        // Keep the failed entry and everything after it — preserve queue order.
        remaining.push(...queue.slice(i));
        break;
      }
    }

    writeQueue(remaining);
    return {
      ok: remaining.length === 0,
      pending: remaining.length,
      failedTransactionId,
      lastError,
    };
  },

  // Remove a specific entry by transactionId without touching the rest.
  dequeue: (transactionId) => {
    const txId = String(transactionId || '').trim();
    if (!txId) return false;
    const queue = readQueue();
    const next = queue.filter((e) => e.transactionId !== txId);
    if (next.length === queue.length) return false;
    writeQueue(next);
    return true;
  },

  clear: () => writeQueue([]),
};
